import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config';
import { Paper } from '@mui/material';

const RegistrationChildCat = ({ childObject, updateChild, validation }) => {
  const [sessions, setSessions] = useState([]);
  useEffect(() => {
    axios
      .get(config.SESSION_API)
      .then(output => {
        setSessions(output.data.response);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const handleFormChange = e => {
    // for students transferring in, no need to indicate current level
    if (e.target.name === 'transfer_from' && Number(childObject.level) !== 1) {
      if (e.target.value !== '') {
        document.getElementById('currentSessionField').classList.add('hidden');
      } else
        document
          .getElementById('currentSessionField')
          .classList.remove('hidden');
    }

    // check for level===1, then hide session_time field cos it's not required
    if (e.target.name === 'level' && childObject.transfer_from === '') {
      if (Number(e.target.value) === 1)
        document.getElementById('currentSessionField').classList.add('hidden');
      else
        document
          .getElementById('currentSessionField')
          .classList.remove('hidden');
    }

    updateChild(e.target);
  };

  const catLevels = Array.from({ length: 10 }, (_, index) => index + 1);

  return (
    <div>
      <Paper elevation={5} sx={{ padding: '20px' }}>
        <TextField
          fullWidth
          label='If applicable, please indicate if your child is transferring in from:'
          select
          margin='dense'
          name='transfer_from'
          value={childObject['transfer_from'] ?? ''}
          onChange={handleFormChange}
          id='child-transfer-from'
        >
          <MenuItem value=''>&nbsp;</MenuItem>
          <MenuItem value='Home_Cat'>Home Catechism</MenuItem>
          <MenuItem value='Bridging'>Bridging Programme</MenuItem>
          <MenuItem value='Another_Parish'>Another Parish</MenuItem>
        </TextField>

        <div className='spacer'></div>

        <TextField
          fullWidth
          required
          error={validation.level}
          helperText={validation.level && 'Please select a level'}
          label='Catechism Level in 2027'
          select
          margin='dense'
          name='level'
          value={childObject['level'] ?? ''}
          onChange={handleFormChange}
          id='child-cat-level'
        >
          {catLevels?.map(level => (
            <MenuItem key={'level' + level} value={level.toString()}>
              Level {level}
            </MenuItem>
          ))}
        </TextField>

        <div className='spacer'></div>

        <div
          className='hidden'
          id='currentSessionField'
          data-cy='child-current-session-hider'
        >
          <TextField
            fullWidth
            error={validation.session_time}
            helperText={
              validation.session_time && 'Please select your session time'
            }
            required
            label='Current Session Timing'
            select
            margin='dense'
            name='session_time'
            value={childObject['session_time'] ?? ''}
            onChange={handleFormChange}
            id='child-current-session'
          >
            {sessions?.map(session => (
              <MenuItem key={session.id} value={session.id.toString()}>
                {session.session}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <TextField
          fullWidth
          label='Preferred Session Timing'
          select
          margin='dense'
          name='preferred_session_time'
          value={childObject['preferred_session_time'] ?? ''}
          onChange={handleFormChange}
          id='child-preferred-session'
        >
          {sessions?.map(session => (
            <MenuItem key={session.id} value={session.id.toString()}>
              {session.session}
            </MenuItem>
          ))}
        </TextField>
        <div className='nanoText errorTxtSpacer'>*Subject to availability</div>

        <div className='spacer'></div>

        <TextField
          label='School in 2027'
          name='school'
          fullWidth
          error={validation.school}
          helperText={
            validation.school && 'Please enter the current school of the child'
          }
          required
          margin='dense'
          value={childObject['school'] ?? ''}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'child-school' }}
        ></TextField>

        <TextField
          required
          fullWidth
          error={validation.school_level}
          helperText={validation.school_level && 'Please select a level'}
          label='School Level in 2027'
          select
          margin='dense'
          name='school_level'
          value={childObject['school_level'] ?? ''}
          onChange={handleFormChange}
          id='child-school-level'
        >
          <MenuItem value='Primary 1'>Pri 1</MenuItem>
          <MenuItem value='Primary 2'>Pri 2</MenuItem>
          <MenuItem value='Primary 3'>Pri 3</MenuItem>
          <MenuItem value='Primary 4'>Pri 4</MenuItem>
          <MenuItem value='Primary 5'>Pri 5</MenuItem>
          <MenuItem value='Primary 6'>Pri 6</MenuItem>
          <MenuItem value='Secondary 1'>Sec 1</MenuItem>
          <MenuItem value='Secondary 2'>Sec 2</MenuItem>
          <MenuItem value='Secondary 3'>Sec 3</MenuItem>
          <MenuItem value='Secondary 4'>Sec 4</MenuItem>
        </TextField>
      </Paper>
    </div>
  );
};

export default RegistrationChildCat;
